import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";

// Route-level code splitting: keep Home eager (LCP), lazy-load everything else so
// public visitors never download the Admin CRM bundle up front.
const About = lazy(() => import("@/pages/About"));
const Announcements = lazy(() => import("@/pages/Announcements"));
const AnnouncementDetail = lazy(() => import("@/pages/AnnouncementDetail"));
const Programs = lazy(() => import("@/pages/Programs"));
const Events = lazy(() => import("@/pages/Events"));
const Gallery = lazy(() => import("@/pages/Gallery"));
const RequestHelp = lazy(() => import("@/pages/RequestHelp"));
const RequestPrayer = lazy(() => import("@/pages/RequestPrayer"));
const GetInvolved = lazy(() => import("@/pages/GetInvolved"));
const Contact = lazy(() => import("@/pages/Contact"));
const PublicSchedule = lazy(() => import("@/pages/PublicSchedule"));
const AdminApp = lazy(() => import("@/admin/AdminApp"));

const RouteFallback = () => (
  <div className="min-h-[50vh] flex items-center justify-center" role="status" aria-label="Loading">
    <div className="w-8 h-8 border-2 border-teal border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SiteProvider>
          <Toaster position="top-center" richColors />
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/announcements" element={<Announcements />} />
                <Route path="/announcements/:id" element={<AnnouncementDetail />} />
                <Route path="/programs" element={<Programs />} />
                <Route path="/events" element={<Events />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/request-help" element={<RequestHelp />} />
                <Route path="/request-prayer" element={<RequestPrayer />} />
                <Route path="/get-involved" element={<GetInvolved />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/schedule" element={<PublicSchedule />} />
              </Route>
              <Route path="/admin/*" element={<AdminApp />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </SiteProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
